import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const appInsights = new ApplicationInsights({
  config: {
    connectionString: window.globalConfig.APPINSIGHTS_CONNECTION_STRING || 
      "InstrumentationKey=YOUR-INSTRUMENTATION-KEY-HERE",
    enableAutoRouteTracking: true,
    enableUnhandledPromiseRejectionTracking: true,
    enableCorsCorrelation: true,
    enableAjaxErrorStatusText: true,
  },
});

appInsights.loadAppInsights();
appInsights.trackPageView();


window.onerror = function (message, source, lineno, colno, error) {
  appInsights.trackException({
    exception: error || new Error(message),
    severityLevel: 3,
    properties: { source, lineno, colno }
  });
};


window.onunhandledrejection = function (event) {
  appInsights.trackException({
    exception: event.reason || new Error('Unhandled Promise Rejection'),
    severityLevel: 2
  });
};

export default appInsights;
